import { defineMessages } from 'react-intl';

const scope = 'app.builder.Knowledge.components.KnowledgeMapCollaborators';

export default defineMessages({
  grantPermissionError: {
    id: `${scope}.grant.permission.error`,
    defaultMessage: 'Cannot grant permission to user.',
  },
  revokePermissionError: {
    id: `${scope}.revoke.permission.error`,
    defaultMessage: 'Cannot revoke permission for user.',
  },

});